import type { NoteComment } from '@witmetrics/utils';
import { isJson } from '@witmetrics/utils/strings';
import { API } from '@/api';

export const classes = {
  notesField: 'border border-grey-3',
  comment:
    'flex flex-col items-start py-[11px] pr-[13px] pl-5 border-t border-solid border-black/[0.055] bg-black/[0.025] dark:border-white/[0.05] dark:bg-white/[0.03]',
  note: 'mt-[5px] text-[12.5px] text-taupe-2 dark:text-mauve-2',
};

export const styles = {
  comment: {
    '& .options-wrapper': {
      opacity: '0',
      transition: 'opacity 0.1s',
    },
    '&:hover .options-wrapper': {
      opacity: '1',
    },
  },
};

export async function updateNoteComment(commentId: number, message: string) {
  return API.Notes.updateNoteComment(commentId, { message });
}

export function parseContent({ content }: NoteComment): string {
  // Comment could either be a plain string *or* a JSON object depending on its type
  if (isJson(content)) {
    const parsed = JSON.parse(content);
    return parsed.message || parsed;
  } else return content;
}
